import { Routes, Route, Navigate } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { useArcheAdmin } from '@/auth/hooks/useArcheAdmin';
import { TaskListPage } from './TaskListPage';
import { TaskDetailPage } from './TaskDetailPage';
import { AdminDashboardPage } from './AdminDashboardPage';
import { AdminTaskListPage } from './AdminTaskListPage';
import { AdminTaskTreePage } from './AdminTaskTreePage';
import { AdminCreateTaskPage } from './AdminCreateTaskPage';
import { AdminEditTaskPage } from './AdminEditTaskPage';
import { AdminUserTaskStatusesPage } from './AdminUserTaskStatusesPage';

export function LitLegionArchePage() {
  // Server route gate: `requireAdminOrLitcraftAdmin` (docs/api-admin.md).
  const isAdmin = useArcheAdmin('litcraft_admin');

  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<TaskListPage />} />
        <Route path="/tasks/:taskId" element={<TaskDetailPage />} />
        <Route
          path="/admin"
          element={isAdmin ? <AdminDashboardPage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/admin/tasks"
          element={isAdmin ? <AdminTaskListPage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/admin/tasks/tree"
          element={isAdmin ? <AdminTaskTreePage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/admin/tasks/create"
          element={isAdmin ? <AdminCreateTaskPage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/admin/tasks/:taskId/edit"
          element={isAdmin ? <AdminEditTaskPage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/admin/user-statuses"
          element={isAdmin ? <AdminUserTaskStatusesPage /> : <Navigate to="/" replace />}
        />
      </Routes>
    </ArcheLayout>
  );
}
